import React from 'react';
import { FiClipboard, FiAlertCircle } from 'react-icons/fi';

/**
 * Affiche les champs saisis dans le formulaire de demande de mission.
 */
export default function MissionRequestFormSection({ missionForm }) {
  const fields = missionForm?.fields || [];
  const visibleFields = fields.filter((f) => f.display);

  return (
    <div className="mb-8 pt-8 border-t border-gray-700">
      <div className="flex items-center mb-6 pb-4 border-b border-gray-700">
        <div className="w-10 h-10 bg-yellow-600/20 border border-yellow-600/50 rounded-lg flex items-center justify-center mr-3">
          <FiClipboard className="text-yellow-400" />
        </div>
        <div>
          <h3 className="text-xl font-bold text-gray-100">
            Données du formulaire de demande
          </h3>
          <p className="text-sm text-gray-400 mt-0.5">
            Informations saisies par le client lors de la création de la mission
          </p>
        </div>
      </div>

      {visibleFields.length === 0 ? (
        <div className="rounded-xl border border-dashed border-gray-600 bg-gray-900/40 p-6 flex items-start gap-3 text-gray-400">
          <FiAlertCircle className="w-5 h-5 shrink-0 mt-0.5 text-amber-400" />
          <p className="text-sm">
            Aucune donnée détaillée du formulaire n&apos;a été enregistrée pour cette mission
            (seules les adresses et dates sont disponibles).
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {visibleFields.map((field) => (
            <div
              key={field.key}
              className={
                field.key === 'description' || field.key === 'chambres' || field.key === 'notes'
                  ? 'md:col-span-2'
                  : ''
              }
            >
              <label className="block text-sm font-semibold text-gray-300 mb-2">{field.label}</label>
              <p className="px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white text-sm whitespace-pre-wrap">
                {field.display}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

